import type { SVGProps } from 'react';

const SvgTextUnderscore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18.5 16.5h-2.78c.31-.3.57-.64.79-1.02.39-.7.59-1.52.59-2.42V7.27c0-.31-.1-.58-.29-.8q-.3-.33-.78-.33c-.48 0-.58.11-.77.33-.18.21-.28.48-.28.79v5.79c0 .5-.12.94-.34 1.3-.23.37-.53.65-.9.85-.71.39-1.61.42-2.34 0-.35-.2-.64-.48-.86-.85-.21-.36-.32-.8-.32-1.31V7.25c0-.32-.12-.59-.34-.81-.23-.21-.48-.32-.77-.32-.34 0-.62.11-.84.32-.22.22-.33.49-.33.8v5.79c0 .91.2 1.72.59 2.42.21.39.48.73.79 1.02H6.53c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z"
    />
  </svg>
);
export default SvgTextUnderscore;
